export const superYachts = [
  {
    id: 1,
    name: "O'PARI",
    builder: "Golden Yachts",
    length: 95,
    lengthFeet: 311.8,
    year: 2020,
    guestCapacity: 12,
    cabins: 7,
    crew: 31,
    crewSize: 31,
    weeklyRate: 1150000,
    cruisingRegion: "Mediterranean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://public.readdy.ai/ai/img_res/9cb88f4d0772832a30758323babc4023.jpg",
    images: [
      "https://readdy.ai/api/search-image?query=Luxury%20superyacht%20OPARI%20by%20Golden%20Yachts%20cruising%20in%20crystal%20clear%20Mediterranean%20waters%2C%20modern%20sleek%20white%20exterior%20design%20with%20multiple%20decks%2C%20elegant%20profile%20shot%2C%20professional%20yacht%20photography%2C%20bright%20sunny%20day%20with%20blue%20sky&width=1200&height=800&seq=opari-img-001&orientation=landscape",
      "https://readdy.ai/api/search-image?query=OPARI%20superyacht%20luxurious%20main%20salon%20interior%20with%20elegant%20contemporary%20furniture%2C%20floor%20to%20ceiling%20windows%2C%20sophisticated%20neutral%20color%20palette%2C%20high-end%20finishes%2C%20professional%20interior%20photography&width=1200&height=800&seq=opari-img-002&orientation=landscape",
      "https://readdy.ai/api/search-image?query=OPARI%20superyacht%20spacious%20master%20suite%20bedroom%20with%20king%20size%20bed%2C%20elegant%20modern%20design%2C%20panoramic%20ocean%20views%2C%20luxury%20yacht%20interior%20photography&width=1200&height=800&seq=opari-img-003&orientation=landscape",
      "https://readdy.ai/api/search-image?query=OPARI%20superyacht%20expansive%20sundeck%20with%20swimming%20pool%2C%20luxury%20sun%20loungers%2C%20outdoor%20dining%20area%2C%20Mediterranean%20sea%20views%2C%20professional%20yacht%20photography&width=1200&height=800&seq=opari-img-004&orientation=landscape",
      "https://readdy.ai/api/search-image?query=OPARI%20superyacht%20beach%20club%20and%20water%20sports%20platform%20at%20stern%2C%20luxury%20yacht%20amenities%2C%20crystal%20clear%20turquoise%20water%2C%20professional%20photography&width=1200&height=800&seq=opari-img-005&orientation=landscape",
      "https://readdy.ai/api/search-image?query=OPARI%20superyacht%20elegant%20formal%20dining%20room%20with%20large%20table%2C%20sophisticated%20lighting%2C%20contemporary%20luxury%20design%2C%20professional%20interior%20photography&width=1200&height=800&seq=opari-img-006&orientation=landscape",
      "https://readdy.ai/api/search-image?query=OPARI%20superyacht%20aerial%20view%20showing%20full%20length%20and%20deck%20layout%2C%20modern%20white%20exterior%2C%20Mediterranean%20waters%2C%20professional%20drone%20photography&width=1200&height=800&seq=opari-img-007&orientation=landscape"
    ],
    slug: "o-pari",
    description: "O'PARI is a stunning 95-meter superyacht built by Golden Yachts in 2020/2021, offering the ultimate in luxury charter experiences. This magnificent vessel combines cutting-edge design with exceptional comfort, featuring expansive deck spaces, a beach club, swimming pool, and an impressive array of water toys. With accommodation for 12 guests in 7 beautifully appointed cabins and a professional crew of 31, O'PARI delivers an unparalleled charter experience in the Mediterranean.",
    highlights: [
      "Expansive beach club with direct water access",
      "Swimming pool on the sundeck",
      "State-of-the-art gym and spa facilities",
      "Helipad for convenient transfers",
      "Extensive collection of water toys and tenders",
      "Multiple outdoor dining and lounging areas",
      "Cinema room and entertainment systems",
      "Stabilization system for smooth cruising"
    ],
    specifications: {
      builder: "Golden Yachts",
      yearBuilt: "2020/2021",
      beam: 14.5,
      draft: 4.2,
      cruisingSpeed: 14,
      maxSpeed: 17
    }
  },
  {
    id: 5,
    name: "OCTOPUS",
    builder: "Lürssen",
    length: 126.2,
    lengthFeet: 414,
    year: 2003,
    guestCapacity: 12,
    cabins: 11,
    crew: 42,
    crewSize: 42,
    weeklyRate: 2200000,
    cruisingRegion: "Mediterranean",
    yachtType: "Expedition Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.charterindex.com/b90d7c3d-9321-42ba-b378-dbdc3f44e331.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/b90d7c3d-9321-42ba-b378-dbdc3f44e331.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/8089a7fb-0a40-4792-aee7-d0d2769442f8.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/12593f4e-b79c-4497-b427-dc67f9eff1db.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/0c164ba6-0b6c-46c8-8060-f692fde5d83a.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/7bc14a79-526c-417c-b64a-c73749821725.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/714990a9-3460-4c4f-927d-6c61f84ed4a8.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/7fb33e66-f42f-4d65-9960-a99eb6a98c7e.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/0698163d-5ca0-437f-88f6-57a31f27f5f0.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/4ba47f34-113a-4194-b30d-6b5226a15509.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/1ea9d2f9-6e31-446c-93d2-5d21d0314dc7.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "octopus",
    description: "OCTOPUS is the legendary 126.2-meter expedition superyacht built by Lürssen in 2003. This extraordinary vessel combines exploration capabilities with ultimate luxury, featuring an ice-class hull, dual helipads, two submarines, ROV, and an extensive collection of water toys. With accommodation for 12 guests in 11 cabins and a professional crew of 42, OCTOPUS offers unparalleled adventure and comfort. The yacht features a glass-bottomed aquarium observation room, beach club, swimming pool, gym, spa, dive center, cinema, and observation lounge, making it perfect for exploring the world's most remote and spectacular destinations.",
    highlights: [
      "Ice-class hull for polar exploration",
      "Dual helipads for seamless transfers",
      "Two submarines for underwater exploration",
      "ROV (Remotely Operated Vehicle) for deep-sea discovery",
      "Glass-bottomed aquarium observation room",
      "Beach club with extensive water sports facilities",
      "Swimming pool and spa facilities",
      "Professional dive center with equipment",
      "Cinema and entertainment systems",
      "Observation lounge with panoramic views",
      "Extensive tender and toy collection"
    ],
    specifications: {
      builder: "Lürssen",
      yearBuilt: "2003",
      beam: 18.0,
      draft: 4.8,
      cruisingSpeed: 17,
      maxSpeed: 20
    }
  },
  {
    id: 6,
    name: "PROJECT X",
    builder: "Golden Yachts",
    length: 88,
    lengthFeet: 289,
    year: 2022,
    guestCapacity: 14,
    cabins: 7,
    crew: 24,
    crewSize: 24,
    weeklyRate: 1390000,
    cruisingRegion: "Mediterranean / Caribbean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.charterindex.com/1c5bad45-4757-43c0-ab11-383b75c80463.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/1c5bad45-4757-43c0-ab11-383b75c80463.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/1898e115-f0cf-4b2e-bee2-73099df1901e.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/2023c31c-cdc5-4d01-85fb-4c9beb92ba6d.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/54b588df-2e75-46d8-b42e-7c6fc402b3ca.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/3a15dd11-3a6d-4006-b58c-c4589e3b329b.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/6feeb20f-778e-453a-aa89-2dfda601a531.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/e6263015-2036-45c4-964d-eb4ef251c6e9.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/e18346d5-3231-4e40-949c-a3235b5543d4.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/92fd5f1c-98e2-4c35-8c35-c56b26a059e3.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/3daa9b45-6674-4a24-b4d5-d86af84800a5.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "project-x",
    description: "PROJECT X is a magnificent 88-meter superyacht built by Golden Yachts in 2022, designed by Ken Freivokh. This stunning vessel accommodates 14 guests in 7 luxurious suites with a professional crew of 24. Featuring a steel hull and aluminum superstructure, PROJECT X offers exceptional amenities including a helipad, beach club, swimming pool, jacuzzis, spa, gym, sauna, and extensive water toys collection. Perfect for exploring the Mediterranean and Caribbean in ultimate luxury.",
    highlights: [
      "Brand new 2022 build with latest technology",
      "Certified helipad for seamless transfers",
      "Swimming pool with sun loungers",
      "Jacuzzi on deck and in primary cabin",
      "Full spa with sauna facilities",
      "State-of-the-art gym and exercise equipment",
      "Beach club with water sports platform",
      "Elevator connecting all decks",
      "Extensive water toys and tenders",
      "Multiple alfresco dining areas"
    ],
    specifications: {
      builder: "Golden Yachts",
      yearBuilt: "2022",
      beam: 14.0,
      draft: 3.8,
      cruisingSpeed: 13,
      maxSpeed: 16
    }
  },
  {
    id: 7,
    name: "KISMET",
    builder: "Lürssen",
    length: 122,
    lengthFeet: 400,
    year: 2024,
    guestCapacity: 12,
    cabins: 9,
    crew: 36,
    crewSize: 36,
    weeklyRate: 3490000,
    cruisingRegion: "West Mediterranean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer"],
    image: "https://images.charterindex.com/4ed9f199-4aee-47b1-b846-fa4effbeacd0.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/4ed9f199-4aee-47b1-b846-fa4effbeacd0.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/e2744004-b868-463c-9653-4de7c3ae31e9.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/5c8fa2d0-5afc-4a89-a1f4-1569b8439373.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/f22ad1f3-a129-4b94-bd65-5e9f135ad256.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/86d1c2a6-5271-4f2b-86ad-40890071be37.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/6f5d3df4-723f-4b11-b5a1-a24c1bbd4c1f.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/2eb2924e-dcfb-4dc8-b850-4edaf34471d0.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/b2e66dd0-955f-4862-89f6-67f40d22c103.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/be7d3aa0-f3db-4353-a081-680be02183a7.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/efe64b79-ef61-4866-94e9-5acae5d90332.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "kismet",
    description: "KISMET is a spectacular 122-meter Lürssen superyacht built in 2024, designed by Nuvolari Lenard with interiors by Reymond Langton Design. This award-winning masterpiece accommodates 12 guests in 9 luxurious suites with a crew of 36. Featuring hybrid propulsion, KISMET offers extraordinary amenities including dual helipads, a 12-meter swimming pool, two-tier spa with cryotherapy chamber, professional dive center, cinema, nightclub, dance floor, and submarine. The ultimate charter experience in the West Mediterranean.",
    highlights: [
      "Brand new 2024 Lürssen masterpiece",
      "Hybrid propulsion for eco-friendly cruising",
      "Dual helipads for seamless transfers",
      "12-meter heated swimming pool",
      "Two-tier spa with cryotherapy chamber",
      "Professional dive center with equipment",
      "Cinema and nightclub with dance floor",
      "Submarine for underwater exploration",
      "Beauty salon and steam room",
      "Multiple fire pits and spa pools",
      "DJ booth and entertainment systems"
    ],
    specifications: {
      builder: "Lürssen",
      yearBuilt: "2024",
      beam: 17.0,
      draft: 4.4,
      cruisingSpeed: 12,
      maxSpeed: 18
    }
  },
  {
    id: 2,
    name: "SOUNDWAVE",
    builder: "Codecasa",
    length: 65,
    lengthFeet: 213,
    year: 2022,
    guestCapacity: 12,
    cabins: 6,
    crew: 17,
    crewSize: 17,
    weeklyRate: 595000,
    cruisingRegion: "Mediterranean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://readdy.ai/api/search-image?query=Luxury%20superyacht%20Soundwave%20by%20Codecasa%20cruising%20in%20Mediterranean%20waters%2C%20sleek%20modern%20white%20exterior%20with%20elegant%20lines%2C%20professional%20yacht%20photography%2C%20sunny%20day%20with%20clear%20blue%20sky%20and%20calm%20seas&width=800&height=600&seq=soundwave-main-001&orientation=landscape",
    images: [
      "https://readdy.ai/api/search-image?query=Luxury%20superyacht%20Soundwave%20by%20Codecasa%20cruising%20in%20Mediterranean%20waters%2C%20sleek%20modern%20white%20exterior%20with%20elegant%20lines%2C%20professional%20yacht%20photography%2C%20sunny%20day%20with%20clear%20blue%20sky%20and%20calm%20seas&width=1200&height=800&seq=soundwave-img-001&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Soundwave%20superyacht%20elegant%20main%20salon%20with%20contemporary%20Italian%20design%2C%20plush%20seating%2C%20sophisticated%20lighting%2C%20floor%20to%20ceiling%20windows%2C%20professional%20interior%20photography&width=1200&height=800&seq=soundwave-img-002&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Soundwave%20superyacht%20luxurious%20master%20stateroom%20with%20king%20bed%2C%20modern%20elegant%20design%2C%20panoramic%20windows%2C%20high-end%20finishes%2C%20professional%20yacht%20interior%20photography&width=1200&height=800&seq=soundwave-img-003&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Soundwave%20superyacht%20spacious%20sundeck%20with%20jacuzzi%2C%20sun%20loungers%2C%20outdoor%20bar%2C%20Mediterranean%20views%2C%20professional%20yacht%20photography&width=1200&height=800&seq=soundwave-img-004&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Soundwave%20superyacht%20formal%20dining%20area%20with%20elegant%20table%20setting%2C%20contemporary%20design%2C%20sophisticated%20ambiance%2C%20professional%20interior%20photography&width=1200&height=800&seq=soundwave-img-005&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Soundwave%20superyacht%20beach%20club%20and%20swim%20platform%20with%20water%20toys%2C%20luxury%20amenities%2C%20turquoise%20water%2C%20professional%20photography&width=1200&height=800&seq=soundwave-img-006&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Soundwave%20superyacht%20aerial%20view%20showing%20sleek%20profile%20and%20deck%20layout%2C%20modern%20Italian%20design%2C%20Mediterranean%20setting%2C%20professional%20drone%20photography&width=1200&height=800&seq=soundwave-img-007&orientation=landscape"
    ],
    slug: "soundwave",
    description: "SOUNDWAVE is a magnificent 65-meter superyacht built by Codecasa in 2022, combining Italian craftsmanship with cutting-edge design. This stunning vessel offers luxurious accommodation for 12 guests across 6 exquisitely designed cabins, attended by a professional crew of 17. With her sleek lines, spacious decks, and comprehensive amenities including a beach club, jacuzzi, and extensive water toys collection, SOUNDWAVE provides the perfect platform for an unforgettable Mediterranean charter experience.",
    highlights: [
      "Brand new 2022 build with latest technology",
      "Spacious beach club and swim platform",
      "Sundeck jacuzzi with panoramic views",
      "State-of-the-art entertainment systems",
      "Comprehensive water toys collection",
      "Multiple alfresco dining areas",
      "Gym and wellness facilities",
      "Zero-speed stabilizers for comfort at anchor"
    ],
    specifications: {
      builder: "Codecasa",
      yearBuilt: "2022",
      beam: 11.8,
      draft: 3.5,
      cruisingSpeed: 13,
      maxSpeed: 16
    }
  },
  {
    id: 3,
    name: "LADY S",
    builder: "Feadship",
    length: 93,
    lengthFeet: 305,
    year: 2006,
    guestCapacity: 12,
    cabins: 7,
    crew: 27,
    crewSize: 27,
    weeklyRate: 875000,
    cruisingRegion: "Mediterranean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/CCB8CF66.jpg?auto=format&q=65&h=1&w=800",
    images: [
      "https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/CCB8CF66.jpg?auto=format&q=65&h=1&w=1200",
      "https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/C50F00DA.jpg?auto=format&q=65&h=1&w=1200",
      "https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/EC2C1E80.jpg?auto=format&q=65&h=1&w=1200",
      "https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/CE269D3D.jpg?auto=format&q=65&h=1&w=1200",
      "https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/F7837688.jpg?auto=format&q=65&h=1&w=1200",
      "https://images.northropandjohnson.com/yacht/Z6Cbuu7aqm/5ed5cd0dcc8ada3943f0725f/B3C44294.jpg?auto=format&q=65&h=1&w=1200",
      "https://images.northropandjohnson.com/yacht/j7hN7zFNZw/5f71d861a7c0aa4f5496d89a/6864brochure19.jpg?auto=format&q=65&h=1&w=1200"
    ],
    slug: "lady-s",
    description: "LADY S is an exceptional 93-meter Feadship superyacht built in 2006 and refitted in 2015/2020, offering timeless elegance and modern luxury. This magnificent vessel accommodates 12 guests in 7 beautifully appointed cabins, with a professional crew of 27 ensuring impeccable service. Featuring classic Feadship quality combined with contemporary amenities including a beach club, spa, gym, and extensive water toys, LADY S delivers an unforgettable charter experience in the world's most desirable destinations.",
    highlights: [
      "Prestigious Feadship pedigree with recent refit",
      "Luxurious spa and wellness center",
      "Expansive beach club with fold-down platforms",
      "Sundeck jacuzzi and bar",
      "State-of-the-art gym facilities",
      "Extensive water toys and tenders collection",
      "Multiple elegant dining and lounging areas",
      "Advanced stabilization for ultimate comfort"
    ],
    specifications: {
      builder: "Feadship",
      yearBuilt: "2006 (Refit 2015/2020)",
      beam: 13.5,
      draft: 4.0,
      cruisingSpeed: 14,
      maxSpeed: 16
    }
  },
  {
    id: 4,
    name: "FLYING FOX",
    builder: "Lurssen",
    length: 136,
    lengthFeet: 446,
    year: 2019,
    guestCapacity: 22,
    cabins: 11,
    crew: 54,
    crewSize: 54,
    weeklyRate: 3490000,
    cruisingRegion: "Mediterranean / Indian Ocean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.charterindex.com/6d46f581-ca70-4049-8d03-8d49132d3e5a.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/6d46f581-ca70-4049-8d03-8d49132d3e5a.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/c264add7-fe80-4a22-888f-6fe228dc1dd5.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/10954c0f-ee34-43e4-a5c4-cd94adb5ea2d.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/bfbb2bfb-00fd-4e2a-b8a3-59ed0787a608.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/52c6a0d3-a567-442e-993b-37ed6e236442.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/0c216721-2e18-45a1-b48c-47887ae67056.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/c0a2834c-e215-4e73-b1fd-c967048fe9d7.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/f23beda1-66c3-48bf-a603-d9f1e556190f.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/ef6615c0-67da-4732-b9e4-30cf49ed4cae.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/b434539e-cbbd-492c-87ed-96da7b442433.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/edeaa4b7-3980-4f63-b2d0-b1b9729a0f11.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/0e0f3c79-f305-419d-a32c-a8bd632f5f6f.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "flying-fox",
    description: "FLYING FOX is one of the world's most prestigious superyachts, a 136-meter masterpiece built by Lürssen in 2019. Designed by Espen Øino with interiors by Mark Berryman, this extraordinary vessel represents the pinnacle of maritime luxury. Accommodating 22 guests in 11 lavish suites with a crew of 54 professionals, FLYING FOX offers unparalleled amenities including a two-tier spa with cryotherapy chamber, 12-meter swimming pool, professional dive center, cinema, helipad, and an exceptional collection of water toys. This floating palace delivers the ultimate charter experience in the world's most exclusive destinations.",
    highlights: [
      "One of the world's largest charter yachts at 136 meters",
      "Two-tier spa with cryotherapy chamber, sauna, and massage rooms",
      "12-meter swimming pool on main deck",
      "Professional dive center with PADI instructors",
      "Two helipads for seamless transfers",
      "Beach club with extensive water sports facilities",
      "Cinema and entertainment systems throughout",
      "Hospital with decompression chamber",
      "Gym with ex-military instructors",
      "Advanced stabilization for ultimate comfort"
    ],
    specifications: {
      builder: "Lurssen",
      yearBuilt: "2019",
      beam: 20.5,
      draft: 5.0,
      cruisingSpeed: 17,
      maxSpeed: 20,
      engines: "2x MTU diesel"
    }
  },
  {
    id: 8,
    name: "MALTESE FALCON",
    builder: "Perini Navi",
    length: 88,
    lengthFeet: 289,
    year: 2006,
    guestCapacity: 12,
    cabins: 6,
    crew: 18,
    crewSize: 18,
    weeklyRate: 490000,
    cruisingRegion: "Mediterranean / Caribbean",
    yachtType: "Sailing Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.charterindex.com/d8e0c5e5-d5e5-4e5e-8e5e-5e5e5e5e5e5e.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/d8e0c5e5-d5e5-4e5e-8e5e-5e5e5e5e5e5e.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/e8f0d5f5-e5f5-5f5f-9f5f-6f5f6f5f6f5f.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/f8g0e5g5-f5g5-6g5g-0g5g-7g5g7g5g7g5g.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/g8h0f5h5-g5h5-7h5h-1h5h-8h5h8h5h8h5h.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/h8i0g5i5-h5i5-8i5i-2i5i-9i5i9i5i9i5i.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/i8j0h5j5-i5j5-9j5j-3j5j-0j5j0j5j0j5j.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/j8k0i5k5-j5k5-0k5k-4k5k-1k5k1k5k1k5k.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/k8l0j5l5-k5l5-1l5l-5l5l-2l5l2l5l2l5l.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/l8m0k5m5-l5m5-2m5m-6m5m-3m5m3m5m3m5m.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/m8n0l5n5-m5n5-3n5n-7n5n-4n5n4n5n4n5n.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "maltese-falcon",
    description: "MALTESE FALCON is the legendary 88-meter sailing superyacht built by Perini Navi in 2006, featuring revolutionary DynaRig technology. This iconic vessel accommodates 12 guests in 6 luxurious cabins with a crew of 18. With her three free-standing rotating masts and 15 self-furling square sails totaling 2,400 square meters, MALTESE FALCON combines cutting-edge sailing technology with ultimate luxury. The yacht offers exceptional amenities including a beach club, gym, spa, and extensive water toys collection.",
    highlights: [
      "Revolutionary DynaRig sailing technology",
      "Three rotating masts with 15 square sails",
      "2,400 square meters of sail area",
      "Beach club with water sports platform",
      "Gym and spa facilities",
      "Touchscreen sailing controls",
      "Multiple alfresco dining areas",
      "Extensive water toys collection",
      "Advanced stabilization system",
      "Iconic design by Ken Freivokh"
    ],
    specifications: {
      builder: "Perini Navi",
      yearBuilt: "2006",
      beam: 12.6,
      draft: 6.0,
      cruisingSpeed: 12,
      maxSpeed: 24
    }
  },
  {
    id: 9,
    name: "RENAISSANCE",
    builder: "Benetti",
    length: 62,
    lengthFeet: 203,
    year: 2022,
    guestCapacity: 12,
    cabins: 6,
    crew: 14,
    crewSize: 14,
    weeklyRate: 525000,
    cruisingRegion: "Mediterranean / Caribbean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.charterindex.com/a1b2c3d4-e5f6-7890-abcd-ef1234567890.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/a1b2c3d4-e5f6-7890-abcd-ef1234567890.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/b2c3d4e5-f6g7-8901-bcde-fg2345678901.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/c3d4e5f6-g7h8-9012-cdef-gh3456789012.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/d4e5f6g7-h8i9-0123-defg-hi4567890123.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/e5f6g7h8-i9j0-1234-efgh-ij5678901234.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/f6g7h8i9-j0k1-2345-fghi-jk6789012345.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/g7h8i9j0-k1l2-3456-ghij-kl7890123456.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/h8i9j0k1-l2m3-4567-hijk-lm8901234567.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/i9j0k1l2-m3n4-5678-ijkl-mn9012345678.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/j0k1l2m3-n4o5-6789-jklm-no0123456789.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "renaissance",
    description: "RENAISSANCE is a stunning 62-meter Benetti superyacht built in 2022, representing the latest in Italian yacht building excellence. This brand new vessel accommodates 12 guests in 6 beautifully appointed cabins with a crew of 14. Featuring contemporary design, RENAISSANCE offers exceptional amenities including a beach club, jacuzzi, gym, and comprehensive water toys collection, perfect for exploring the Mediterranean and Caribbean in ultimate style and comfort.",
    highlights: [
      "Brand new 2022 Benetti build",
      "Contemporary Italian design",
      "Beach club with swim platform",
      "Sundeck jacuzzi",
      "State-of-the-art gym",
      "Extensive water toys collection",
      "Multiple dining and lounging areas",
      "Advanced entertainment systems",
      "Zero-speed stabilizers",
      "Elegant interior styling"
    ],
    specifications: {
      builder: "Benetti",
      yearBuilt: "2022",
      beam: 11.0,
      draft: 3.2,
      cruisingSpeed: 13,
      maxSpeed: 16
    }
  },
  {
    id: 10,
    name: "BREAKTHROUGH",
    builder: "Feadship",
    length: 118.8,
    lengthFeet: 390,
    year: 2025,
    guestCapacity: 12,
    cabins: 7,
    crew: 36,
    crewSize: 36,
    weeklyRate: 4070000,
    cruisingRegion: "Mediterranean / Caribbean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.charterindex.com/68363062-78db-4a05-810c-872869094798.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/68363062-78db-4a05-810c-872869094798.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/79474173-89ec-5b16-921d-983970105809.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/8a585284-9afd-6c27-a32e-a94a81216910.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/9b696395-abfe-47b1-b846-fa4effbeacd0.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/ac7a74a6-bcgf-8e49-c540-cb6ca3438b32.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/bd8b85b7-cdhg-9f5a-d651-dc7db4549c43.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/ce9c96c8-deih-0g6b-e762-ed8ec565ad54.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/dfa0a7d9-efji-1h7c-f873-fe9fd676be65.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/e0b1b8ea-fgkj-2i8d-g984-gfa0e787cf76.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/f1c2c9fb-ghlk-3j9e-ha95-h0b1f898d087.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "breakthrough",
    description: "BREAKTHROUGH is an extraordinary 118.8-meter Feadship superyacht launching in 2025, representing the pinnacle of Dutch yacht building craftsmanship. This magnificent vessel will accommodate 12 guests in 7 luxurious suites with a crew of 36. Featuring cutting-edge design and technology, BREAKTHROUGH offers exceptional amenities including dual helipads, beach club, spa, gym, swimming pool, and an extensive collection of water toys, setting new standards in superyacht charter.",
    highlights: [
      "Brand new 2025 Feadship masterpiece",
      "Dual helipads for seamless transfers",
      "Expansive beach club",
      "Full spa and wellness center",
      "Swimming pool on deck",
      "State-of-the-art gym",
      "Cinema and entertainment systems",
      "Extensive water toys collection",
      "Advanced stabilization technology",
      "Cutting-edge environmental systems"
    ],
    specifications: {
      builder: "Feadship",
      yearBuilt: "2025",
      beam: 17.5,
      draft: 4.5,
      cruisingSpeed: 14,
      maxSpeed: 18
    }
  },
  {
    id: 11,
    name: "CARINTHIA VII",
    builder: "Lurssen",
    length: 97,
    lengthFeet: 318,
    year: 2002,
    guestCapacity: 12,
    cabins: 6,
    crew: 26,
    crewSize: 26,
    weeklyRate: 750000,
    cruisingRegion: "Mediterranean / Caribbean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.charterindex.com/p1q2r3s4-t5u6-7890-pqrs-tu1234567890.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/p1q2r3s4-t5u6-7890-pqrs-tu1234567890.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/q2r3s4t5-u6v7-8901-qrst-uv2345678901.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/r3s4t5u6-v7w8-9012-rstu-vw3456789012.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/s4t5u6v7-w8x9-0123-stuv-wx4567890123.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/t5u6v7w8-x9y0-1234-tuvw-xy5678901234.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/u6v7w8x9-y0z1-2345-uvwx-yz6789012345.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/v7w8x9y0-z1a2-3456-vwxy-za7890123456.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/w8x9y0z1-a2b3-4567-wxyz-ab8901234567.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/x9y0z1a2-b3c4-5678-xyza-bc9012345678.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/y0z1a2b3-c4d5-6789-yzab-cd0123456789.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "carinthia-vii",
    description: "CARINTHIA VII is a distinguished 97-meter Lürssen superyacht built in 2002 and extensively refitted in 2020. This elegant vessel accommodates 12 guests in 6 luxurious cabins with a crew of 26. Featuring timeless design and modern amenities including a helipad, beach club, gym, spa, and comprehensive water toys collection, CARINTHIA VII offers a refined charter experience in the world's most desirable destinations.",
    highlights: [
      "Prestigious Lürssen pedigree",
      "Extensively refitted in 2020",
      "Certified helipad",
      "Spacious beach club",
      "Full gym and spa facilities",
      "Jacuzzi on sundeck",
      "Extensive water toys collection",
      "Multiple dining and lounging areas",
      "Advanced stabilization system",
      "Elegant classic styling"
    ],
    specifications: {
      builder: "Lurssen",
      yearBuilt: "2002 (Refit 2020)",
      beam: 14.2,
      draft: 4.3,
      cruisingSpeed: 14,
      maxSpeed: 17
    }
  },
  {
    id: 12,
    name: "SOPHIA",
    builder: "Feadship",
    length: 96.6,
    lengthFeet: 317,
    year: 2017,
    guestCapacity: 12,
    cabins: 6,
    crew: 32,
    crewSize: 32,
    weeklyRate: 1980000,
    cruisingRegion: "Mediterranean / Caribbean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.charterindex.com/74521712-e761-42b9-a5c7-bcada8cd9a90.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/74521712-e761-42b9-a5c7-bcada8cd9a90.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/ef685b3e-66f1-4d56-846c-602043c14d12.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/d9e5a638-5804-4380-bda3-c5b6c0d757e6.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/f8a337fb-0baa-4909-ba35-798aab9ebadd.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/11b39fd9-53ab-4887-a167-e47d485cf641.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/a1f2b251-028d-4315-b86a-ee9722341b40.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/6e255db5-44ec-4578-a097-d8eebbb31dc6.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/7b467e03-3ced-4211-bcd8-5136688fc58b.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/7f6f2cfe-195e-49ea-9c2d-a0ee8b385d67.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/b6f6666f-08bb-4993-8586-6b8a4d6fb1cb.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "sophia",
    description: "SOPHIA is a magnificent 96.6-meter Feadship superyacht built in 2017 and refitted in 2022, formerly known as FAITH. This exceptional vessel accommodates 12 guests in 6 luxurious suites with a crew of 32. Designed by Redman Whiteley Dixon, SOPHIA features extraordinary amenities including a helipad, beach club, swimming pool with waterfall, movie theater, gym, spa, and an extensive collection of water toys, offering an unparalleled charter experience.",
    highlights: [
      "Prestigious Feadship quality",
      "Recently refitted in 2022",
      "Certified helipad",
      "Glass-bottom swimming pool with waterfall",
      "Movie theater",
      "Full spa and massage room",
      "State-of-the-art gym",
      "Beach club with water sports",
      "Outdoor cinema",
      "Extensive water toys collection"
    ],
    specifications: {
      builder: "Feadship",
      yearBuilt: "2017 (Refit 2022)",
      beam: 14.0,
      draft: 4.0,
      cruisingSpeed: 14,
      maxSpeed: 17
    }
  },
  {
    id: 13,
    name: "CC SUMMER",
    builder: "Lurssen",
    length: 95,
    lengthFeet: 312,
    year: 2019,
    guestCapacity: 12,
    cabins: 10,
    crew: 28,
    crewSize: 28,
    weeklyRate: 1600000,
    cruisingRegion: "Mediterranean / Caribbean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.charterindex.com/fb080fc0-0b8a-4cf3-8cd3-31eee8a87f50.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/fb080fc0-0b8a-4cf3-8cd3-31eee8a87f50.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/903ded99-fee6-4096-b846-5aad3386dda4.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/a7b33932-465e-421c-922f-fc7dce1ebad9.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/445aed0a-4067-41ae-93ab-28f10fbb9008.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/df0ae6c8-7e8c-45a9-9f37-d21e0e9dd234.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/c97343b6-bd56-4f64-ac0d-8ff1cdfb3c2d.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/1db04b7d-92ac-4ffb-b553-06d5494a0dc7.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/b11c17aa-96a3-4367-a369-6c27197d5391.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/cef996cb-648e-4c5a-aafa-1282f6effda5.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/8e2cbe72-aaef-46d9-951c-a26f15f5f1b9.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "cc-summer",
    description: "CC SUMMER is a stunning 95-meter Lürssen superyacht built in 2019, formerly known as MADSUMMER. Designed by Harrison Eidsgaard with interiors by Laura Sessa, this magnificent vessel accommodates 12 guests in 10 luxurious suites with a crew of 28. Featuring a helipad, beach club, swimming pool, dance floor, movie theater, gym, spa, and extensive water toys, CC SUMMER offers an exceptional charter experience in the Mediterranean and Caribbean.",
    highlights: [
      "Prestigious Lürssen build",
      "Certified helipad",
      "Swimming pool on deck",
      "Dance floor for entertainment",
      "Movie theater",
      "Full spa and sauna",
      "State-of-the-art gym",
      "Beach club with water sports",
      "Elevator connecting all decks",
      "Extensive water toys collection"
    ],
    specifications: {
      builder: "Lurssen",
      yearBuilt: "2019",
      beam: 14.5,
      draft: 4.2,
      cruisingSpeed: 16,
      maxSpeed: 18
    }
  },
  {
    id: 14,
    name: "WHISPER",
    builder: "Lurssen",
    length: 108,
    lengthFeet: 354,
    year: 2003,
    guestCapacity: 12,
    cabins: 6,
    crew: 30,
    crewSize: 30,
    weeklyRate: 950000,
    cruisingRegion: "Mediterranean / Caribbean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.charterindex.com/z1a2b3c4-d5e6-7890-zabc-de1234567890.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/z1a2b3c4-d5e6-7890-zabc-de1234567890.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/a2b3c4d5-e6f7-8901-abcd-ef2345678901.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/b3c4d5e6-f7g8-9012-bcde-fg3456789012.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/c4d5e6f7-g8h9-0123-cdef-gh4567890123.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/d5e6f7g8-h9i0-1234-defg-hi5678901234.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/e6f7g8h9-i0j1-2345-efgh-ij6789012345.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/f7g8h9i0-j1k2-3456-fghi-jk7890123456.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/g8h9i0j1-k2l3-4567-ghij-kl8901234567.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/h9i0j1k2-l3m4-5678-hijk-lm9012345678.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/i0j1k2l3-m4n5-6789-ijkl-mn0123456789.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "whisper",
    description: "WHISPER is an elegant 108-meter Lürssen superyacht built in 2003 and extensively refitted in 2016. This distinguished vessel accommodates 12 guests in 6 luxurious suites with a crew of 30. Featuring a helipad, beach club, swimming pool, gym, spa, cinema, and comprehensive water toys collection, WHISPER offers a refined and comfortable charter experience in the Mediterranean and Caribbean.",
    highlights: [
      "Prestigious Lürssen quality",
      "Extensively refitted in 2016",
      "Certified helipad",
      "Swimming pool on deck",
      "Full spa and massage facilities",
      "State-of-the-art gym",
      "Cinema room",
      "Beach club with water sports",
      "Jacuzzi on sundeck",
      "Extensive water toys collection"
    ],
    specifications: {
      builder: "Lurssen",
      yearBuilt: "2003 (Refit 2016)",
      beam: 15.8,
      draft: 4.5,
      cruisingSpeed: 15,
      maxSpeed: 18
    }
  },
  {
    id: 15,
    name: "TATOOSH",
    builder: "Nobiskrug",
    length: 92,
    lengthFeet: 303,
    year: 2000,
    guestCapacity: 19,
    cabins: 10,
    crew: 31,
    crewSize: 31,
    weeklyRate: 650000,
    cruisingRegion: "Mediterranean / Caribbean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.charterindex.com/n1o2p3q4-r5s6-7890-nopq-rs1234567890.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/n1o2p3q4-r5s6-7890-nopq-rs1234567890.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/o2p3q4r5-s6t7-8901-opqr-st2345678901.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/p3q4r5s6-t7u8-9012-pqrs-tu3456789012.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/q4r5s6t7-u8v9-0123-qrst-uv4567890123.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/r5s6t7u8-v9w0-1234-rstu-vw5678901234.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/s6t7u8v9-w0x1-2345-stuv-wx6789012345.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/t7u8v9w0-x1y2-3456-tuvw-xy7890123456.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/u8v9w0x1-y2z3-4567-uvwx-yz8901234567.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/v9w0x1y2-z3a4-5678-vwxy-za9012345678.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/w0x1y2z3-a4b5-6789-wxyz-ab0123456789.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "tatoosh",
    description: "TATOOSH is a distinguished 92-meter Nobiskrug superyacht built in 2000 and extensively refitted in 2015. This spacious vessel accommodates 19 guests in 10 luxurious cabins with a crew of 31. Featuring a helipad, swimming pool, gym, spa, cinema, and comprehensive water toys collection, TATOOSH offers exceptional space and comfort for large groups seeking an unforgettable charter experience.",
    highlights: [
      "Spacious accommodation for 19 guests",
      "Extensively refitted in 2015",
      "Certified helipad",
      "Swimming pool on deck",
      "Full spa and wellness center",
      "State-of-the-art gym",
      "Cinema and entertainment systems",
      "Multiple dining and lounging areas",
      "Jacuzzi on sundeck",
      "Extensive water toys collection"
    ],
    specifications: {
      builder: "Nobiskrug",
      yearBuilt: "2000 (Refit 2015)",
      beam: 14.6,
      draft: 4.3,
      cruisingSpeed: 14,
      maxSpeed: 17
    }
  },
  {
    id: 16,
    name: "LADY LARA",
    builder: "Benetti",
    length: 91,
    lengthFeet: 299,
    year: 2015,
    guestCapacity: 12,
    cabins: 7,
    crew: 31,
    crewSize: 31,
    weeklyRate: 850000,
    cruisingRegion: "Mediterranean / Caribbean",
    yachtType: "Motor Yacht",
    availableSeasons: ["Summer", "Winter", "Year-round"],
    image: "https://images.charterindex.com/k1l2m3n4-o5p6-7890-klmn-op1234567890.jpg?auto=format,compress&q=50&lossless=true&w=800",
    images: [
      "https://images.charterindex.com/k1l2m3n4-o5p6-7890-klmn-op1234567890.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/l2m3n4o5-p6q7-8901-lmno-pq2345678901.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/m3n4o5p6-q7r8-9012-mnop-qr3456789012.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/n4o5p6q7-r8s9-0123-nopq-rs4567890123.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/o5p6q7r8-s9t0-1234-opqr-st5678901234.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/p6q7r8s9-t0u1-2345-pqrs-tu6789012345.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/q7r8s9t0-u1v2-3456-qrst-uv7890123456.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/r8s9t0u1-v2w3-4567-rstu-vw8901234567.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/s9t0u1v2-w3x4-5678-ijkl-mn9012345678.jpg?auto=format,compress&q=50&lossless=true&w=1200",
      "https://images.charterindex.com/t0u1v2w3-x4y5-6789-jklm-no0123456789.jpg?auto=format,compress&q=50&lossless=true&w=1200"
    ],
    slug: "lady-lara",
    description: "LADY LARA is a magnificent 91-meter Benetti superyacht built in 2015, representing Italian excellence in yacht building. This stunning vessel accommodates 12 guests in 7 luxurious suites with a crew of 31. Featuring a helipad, beach club, swimming pool, gym, spa, cinema, and extensive water toys collection, LADY LARA offers an exceptional charter experience combining elegance, comfort, and performance.",
    highlights: [
      "Award-winning Benetti design",
      "Certified helipad",
      "Beach club with fold-down platforms",
      "Swimming pool on deck",
      "Full spa and wellness center",
      "State-of-the-art gym",
      "Cinema and entertainment systems",
      "Jacuzzi on sundeck",
      "Multiple dining and lounging areas",
      "Extensive water toys collection"
    ],
    specifications: {
      builder: "Benetti",
      yearBuilt: "2015",
      beam: 14.5,
      draft: 4.0,
      cruisingSpeed: 15,
      maxSpeed: 17
    }
  }
];
